import { render, staticRenderFns } from "./RetailListFunc.vue?vue&type=template&id=93665356&scoped=true"
import script from "./RetailListFunc.vue?vue&type=script&lang=js"
export * from "./RetailListFunc.vue?vue&type=script&lang=js"
import style0 from "./RetailListFunc.vue?vue&type=style&index=0&id=93665356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93665356",
  null
  
)

export default component.exports